module.exports = __webpack_public_path__ + "img/virtual-visit.52310c4f.png";